import { render, staticRenderFns } from "./LiveCounter.vue?vue&type=template&id=60e74cde"
import script from "./LiveCounter.vue?vue&type=script&lang=js"
export * from "./LiveCounter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports